function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  id: "outline",
  d: "M17,2 L22,7 L7,22 L2,22 L2,17 L17,2 Z M13.5,8.5 L4,18 L4,20 L6,20 L15.5,10.5 L13.5,8.5 Z M17,5 L15,7 L17,9 L19,7 L17,5 Z"
});

var _ref2 = /*#__PURE__*/React.createElement("polygon", {
  id: "fill",
  points: "17 5 15 7 17 9 19 7"
});

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  id: "fill",
  points: "13.5 8.5 4 18 4 20 6 20 15.5 10.5"
});

function SvgBlog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBpZD0ib3V0bGluZSIgZD0iTTE3LDIgTDIyLDcgTDcsMjIgTDIsMjIgTDIsMTcgTDE3LDIgWiBNMTMuNSw4LjUgTDQsMTggTDQsMjAgTDYsMjAgTDE1LjUsMTAuNSBMMTMuNSw4LjUgWiBNMTcsNSBMMTUsNyBMMTcsOSBMMTksNyBMMTcsNSBaIi8+PHBvbHlnb24gaWQ9ImZpbGwiIHBvaW50cz0iMTcgNSAxNSA3IDE3IDkgMTkgNyIvPjxwb2x5Z29uIGlkPSJmaWxsIiBwb2ludHM9IjEzLjUgOC41IDQgMTggNCAyMCA2IDIwIDE1LjUgMTAuNSIvPjwvc3ZnPgo=";
export { SvgBlog as ReactComponent };